import { LMSEditor } from 'views/LMS/LMSEditor/LMSEditor';
import { LectureEditor } from '../views/LMS/LectureEditor/LectureEditor';

// import {SectionEditor} from '../views/LMS/SectionEditor/SectionEditor';
import { CourseView } from 'views/LMS/CourseView/CourseView';
import { Courses } from 'views/LMS/Courses/Courses';
import { CourseOverView } from 'views/LMS/CourseOverView/CourseOverView';
import { CourseEnrolled } from 'views/LMS/CoursesEnrolled/CourseEnrolled';

const Routes = [
    {
        path: "/lms/course/:action",
        view: LMSEditor,
        layout: 'appPlain',
        permission: 'lms.course.view',
        title: 'lms.lmseditor.title.create'
    },
    {
        path: "/lms/course/:courseId/:action",
        view: LMSEditor,
        layout: 'appPlain',
        permission: 'lms.course.view',
        title: 'Edit Course'
    },
    {
        path: "/lms/course/:courseID/module/:moduleId/lectures",
        view: LectureEditor,
        layout: 'appPlain',
        permission: 'lms.lecture.view',
        title: 'Edit Lectures',
        mobile: true
    },
    {
        path: "/lms/courses/:courseId/modules",
        view: CourseView,
        layout: 'appPlain',
        title: 'Course Modules',
        permission: 'lms.course.modules.view',
        mobile: true,
        show_nav: false
    },
    {
        path: "/lms/courses/all",
        view: Courses,
        layout: 'app',
        permission: 'lms.courseall.view',
        title: 'Available Courses',
        mobile: true,
    },
    {
        path: "/lms/courses/hidden",
        view: Courses,
        layout: 'app',
        permission: 'lms.course.hidden.view',
        title: 'Archived Courses',
        mobile: true,
    },
    {
        path: "/lms/courses/:courseId",
        permission: 'lms.courseoverview.view',
        view: CourseOverView,
        layout: 'appMobile',
        title: 'Course Overview'
    },
    {
        path: "/lms/courses",
        permission: 'lms.courseenrolled.view',
        view: CourseEnrolled,
        layout: 'app',
        title: 'Enrolled Courses',
        mobile: true
    }
]

export default Routes;